import "./Card.scss";

export enum CardType {
  ELEVATED = "elevated",
}

export enum From {
  LOGIN = "login",
}

interface CardProps {
  children: React.ReactNode;
  cardType?: CardType;
  from?: From;
}

export const Card = ({ children, from }: CardProps) => {
  const cardClass = from === From.LOGIN ? "cp-card--from-login" : "";

  return <div className={`cp-card ${cardClass}`}>{children}</div>;
};

export default Card;
